import { useTranslation } from 'react-i18next';

import { BaseProgressModalWithBanner } from 'components/modals/baseProgressModalWithBanner';

export const RemoveWatermarkProgressModal = () => {
  const { t } = useTranslation();

  return <BaseProgressModalWithBanner title={t('popups.processing_remove_watermark_popup.title')} />;
};
